<template>
  <div>
    <CoolLightBox
        :items="parsedImages"
        :index="index"
        :slideshow="false"
        @close="closeLightBox"
    >
    </CoolLightBox>

    <div class="container grid grid-cols-1 md:grid-cols-3 gap-1 md:gap-3 mx-auto">
      <div class="cursor-pointer content-center place-items-center"
           v-for="(image, imageIndex) in parsedThumbs"
           :key="imageIndex"
           @click="index = imageIndex">

        <lazy-img
            :src="image"
            :placeholder="parsedPlaceholders[imageIndex]"
            class="object-cover h-64 mx-auto"
        />
      </div>
    </div>

  </div>
</template>

<script>

import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

export default {
  components: {
    CoolLightBox
  },
  data: function () {
    return {
      index: null,
      parsedImages: [],
      parsedThumbs: [],
      parsedPlaceholders: []
    };
  },

  mounted() {
    const parsedThumbs = JSON.parse(this.thumbs);
    this.parsedThumbs = parsedThumbs

    let parsedImages = JSON.parse(this.images);
    parsedImages = parsedImages.map(function(value, index) {
      return {
        thumb: parsedThumbs[index],
        src: value,
      }
    });

    this.parsedImages = parsedImages
    this.parsedPlaceholders = JSON.parse(this.placeholders);
  },

  props: ["images", "thumbs", "placeholders"],
  methods: {
    closeLightBox() {
      this.index = null;
    }
  }
};
</script>